const AUTH_MODAL_EVENT = 'auth-modal:open';

/**
 * type: 'unauthenticated' | 'expired'
 */
export function openAuthModalEvent(type = 'unauthenticated') {
  window.dispatchEvent(new CustomEvent(AUTH_MODAL_EVENT, { detail: { type } }));
}

export function listenAuthModalEvent(callback) {
  window.addEventListener(AUTH_MODAL_EVENT, (e) => callback(e.detail));
  return () => window.removeEventListener(AUTH_MODAL_EVENT, (e) => callback(e.detail));
}
